<template>
  <div>
    <div v-if="decodedPreview !== ''">
      <font-awesome-icon icon="question-circle" class="mr-2" />
      <div id="preview" style="display:inline-block;" v-html="decodedPreview"></div>
      <router-link id="link" class="ml-2" v-if="content.id" :to="{ name: 'contentDetails', params: { id: content.id, name: content.name } }">Read more</router-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {};
  },

  props: {
    contentId: {
      required: true
    }
  },

  computed: {
    ...mapGetters("content", ["getContentById"]),

    content: function() {
      return this.getContentById(this.contentId);
    },

    decodedPreview: function() {
      if (this.content) {
        return htmlDecode(this.content.preview);
      }
      return "";
    }
  },

  methods: {
    ...mapActions("content", ["populateContentById"])
  },

  created() {
    this.populateContentById(this.contentId).catch(function(error) {
      console.log(error);
    });
  }
};
</script>

<style scoped>
</style>
